import * as api from '@/store/api/index'
import * as endpoints from '@/store/api/endpoints'
import * as types from "@/store/mutation-types";

const actions = {
  getSettingGroups({commit}, payload) {
    return api.fetch(endpoints.SETTING_GROUPS, payload, commit,(response) => {
      commit(types.SET_SETTING_GROUPS, response.data);
    });
  },
  getGroupSettings({commit}, payload) {
    return api.fetch(endpoints.replaceParams(endpoints.GROUP_SETTINGS, payload)
      , payload, commit,(response) => {
      commit(types.SET_GROUP_SETTINGS, response.data);
    });
  },
  getGroupByCode({commit}, payload) {
    return api.fetch(endpoints.replaceParams(endpoints.GROUP_BY_CODE, payload)
      , payload, commit,(response) => {
        commit(types.SET_GROUP_SETTINGS, response.data);
      });
  },
  getGroupSetting({commit}, payload) {
    return api.fetch(endpoints.GROUP_SETTING+'/'+payload.uuid, payload, commit,(response) => {
      commit(types.SET_GROUP_SETTING, response.data);
    });
  },
  updateGroupSettings({commit}, payload) {
    return api.put(endpoints.replaceParams(endpoints.GROUP_SETTINGS_UPDATE, payload)
      , payload, commit, (response) => {
      commit(types.SET_GROUP_SETTINGS, response.data);
    });
  },
  getSettingValuesByEndpoint({commit}, payload) {
    return api.fetch(payload.endpoint , payload, commit,(response) => {
      commit(types.SET_CUSTOM_SETTING_VALUES, response.data.data);
    });
  },
  getSettingByCode({commit}, payload) {
    return api.fetch(endpoints.replaceParams(endpoints.SETTING_BY_CODE, payload)
      , payload, commit,(response) => {
    });
  },
  getSettingsForGeneralUsage({commit}, payload) {
    const item_codes = [
      'STOCK_QUANTITY_DECIMALS',
      'FRE_GENERAL_DATE_FORMAT',
      'LANG',
      'ENABLE_WORK_CONSUMPTION_AND_PRODUCTION_APPROVAL',
      'USE_PREDEFINED_LOT_NUMBER'
    ];

    return api.fetch(endpoints.SETTINGS_FOR_GENERAL_USAGE, {
      item_codes: item_codes
    }, commit,(response) => {
        commit(types.SET_GENERAL_SETTING_VALUES, response.data);
      });
  },
  getBaseUrl({ state, commit }) {
    if (state.base_url) {
      return Promise.resolve(state.base_url);
    }

    return api.fetch(endpoints.SETTINGS_BASE_URL, {}, commit, (response) => {
      const baseUrl = response?.base_url ?? response?.data?.base_url ?? "";
      commit(types.SET_SETTINGS_BASE_URL, baseUrl);
    }).then((data) => {
      const baseUrl = (data && data.base_url) ? data.base_url : data;
      if (!state.base_url) {
        commit(types.SET_SETTINGS_BASE_URL, baseUrl);
      }
      return baseUrl;
    });
  },
}

export default actions;
